
<template class="max-w-sm">
  <div class="flex items-center justify-center min-h-screen">
    <div class="flex">
      <div class="w-full bg-white p-6 lg:p-12 space-y-8">
        <div>
          <div class="space-y-4 mb-8">
            <h2 class="text-3xl font-bold mb-6 text-left text-bodyText">Verify your email</h2>
            <p class="text-[14px] w-full md:w-[411px] text-grayDark">
              We sent you a six-digit code to your email <span class="font-bold">{{ email }}</span>. Please enter it below to confirm your credentials.
            </p>
            <p v-if="countdown > 0" class="text-[14px] text-grayDark">
              Code expires in <span class="font-bold">{{ countdownMinutes }}:{{ countdownSeconds }}</span>.
            </p>   
          </div>
          <form @submit.prevent="verifyEmail">
            <div class="mb-4">
              <input
                v-model="code"
                placeholder="Enter 6-digit code"
                type="text"
                class="mt-1 block w-full h-[41px] px-3 py-2 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-[#F6F8F9]"
                required
              />
            </div>
            <button
              type="submit"
              class="w-full py-2 px-4 bg-primaryDarkBg hover:bg-primaryDark text-white font-bold rounded
                       hover:bg-gray-200 disabled:bg-gray-400 disabled:cursor-not-allowed disabled:opacity-50"
            >
              <span>Verify email</span>
            </button>
          </form>          
        </div>
        <div>          
          <hr class="w-full border-t-[1px] border-grayLight mb-6">            
          <p class="mt-6 text-primaryDark flex justify-between items-center">
            Didn't receive code?
            <button 
              @click="resendCode"
              :disabled="countdown || resending"
              class="text-primaryDark hover:bg-gray-200 px-3 py-2 bg-[#EEEEEE] rounded-md transition-all duration-200
              hover:bg-gray-200 disabled:bg-gray-400 disabled:cursor-not-allowed disabled:opacity-50"
            >
              {{ resending ? 'Resending...' : 'Resend Code' }}
            </button>
          </p>   
        </div>
      </div>    
    </div>              
  </div>
</template>

<script>
import apiClient from '@/axios';

export default {
  name: 'VerifyEmail',
  components: {
  },
  data() {
    return {
      code: '', // Bind the code input here
      resending: false, // Tracks if resend request is in progress
      countdown: 60, // Countdown in seconds (1 minute)
      intervalId: null,
    };
  },
  computed: {
    email() {
      return this.$route.params.email; // Get the email from route params
    },
    countdownMinutes() {
      return Math.floor(this.countdown / 60).toString().padStart(2, '0'); // Format minutes
    },
    countdownSeconds() {
      return (this.countdown % 60).toString().padStart(2, '0'); // Format seconds
    },
  },
  methods: {
    startCountdown() {
      const endTime = new Date().getTime() + this.countdown * 1000;
      localStorage.setItem('countdownEndTime', new Date(endTime).toISOString());

      this.intervalId = setInterval(() => {
        const remainingTime = Math.floor((endTime - new Date().getTime()) / 1000);
        if (remainingTime > 0) {
          this.countdown = remainingTime;
        } else {
          this.countdown = 0;
          clearInterval(this.intervalId);
          localStorage.removeItem('countdownEndTime'); // Timer expired, remove from localStorage
        }
      }, 1000);
    },

    resetCountdown() {
      clearInterval(this.intervalId); // Clear any existing timer
      this.countdown = 60; // Reset to initial countdown value
      this.startCountdown(); // Restart with new timer
    },
    // resetCountdown() {
    //   clearInterval(this.intervalId); // Clear any existing timer
    //   this.countdown = 60; // Reset countdown to 60 seconds
    //   this.intervalId = setInterval(() => {
    //     if (this.countdown > 0) {
    //       this.countdown--;
    //     } else {
    //       clearInterval(this.intervalId); // Stop the timer when countdown reaches 0
    //     }
    //   }, 1000);
    // },

    // async verifyEmail() {
    //   this.errorMessage = ''; // Reset the error message
    //   this.resendMessage = '';
    //   try {
    //     await apiClient.post('/web/verify_email', null, {
    //       params: {
    //         email: this.email,
    //         code: this.code,
    //       },
    //       headers: { 'Content-Type': 'application/json' },
    //     });

    //     console.log('Email verified successfully');
    //     // await this.fetchUserData();

    //     this.$router.push('/login');


    //   } catch (error) {
    //     this.errorMessage = error.response?.data?.message;
    //     // if (error.response && error.response.status === 400) {
    //     //   this.errorMessage =
    //     //     error.response.data.message ||
    //     //     'An error occurred while verifying your email.';
    //     // } else {
    //     //   this.errorMessage = 'An unexpected error occurred. Please try again later.';
    //     // }
    //     console.error('Error verifying email:', error);
    //     console.error('Error verifying email:', this.errorMessage);

    //   }
    // },

    async verifyEmail() {
      try {
        await apiClient.post('/web/verify_email', null, {
          params: {
            email: this.email,
            code: this.code,
          },
          headers: { 'Content-Type': 'application/json' },
        });

        console.log('Email verified successfully');
        this.$router.push('/login'); // Redirect to login after successful verification

      } catch (error) {
        const statusCode = error.response?.status;
        const errorMessage = error.response?.data?.message;
        if (statusCode === 400 && errorMessage.includes('User is already verified')) {
        console.log('User is already verified.');
        this.$toast.info('Your email is already verified. Redirecting to login...');
        
        // Show message for 5 seconds before redirecting
        setTimeout(() => {
          this.$router.push('/login');
        }, 5000);
      } else {
        this.$toast.error(errorMessage || 'An unexpected error occurred. Please try again later.');
      }
        console.error('Error verifying email:', error);
      }
    },


    // async fetchUserData() {
    //   try {
    //     const token = localStorage.getItem('token');
    //     if (!token) throw new Error('Token not found. Please log in.');

    //     const response = await apiClient.post('/web/current_user', null, {
    //       headers: { Authorization: `Bearer ${token}` },
    //     });

    //     const user = response.data.user;
    //     const userRole = user.role;

    //     // Commit to Vuex store and localStorage
    //     this.$store.commit('setUser', user); // Set user in Vuex
    //     localStorage.setItem('role', userRole);

    //     console.log('User role set:', userRole);
    //     console.log('Vuex store state role:', this.$store.state.role);

    //     // Redirect based on user role
    //     if (userRole === 'user') {
    //       this.$router.push('/awaiting-approval');
    //     } else {
    //       this.$router.push('/dashboard');
    //     }
    //   } catch (error) {
    //     console.error('Error fetching user data:', error);
    //     throw new Error('Fetching user data failed');
    //   }
    // },

    async resendCode() {
      this.resending = true;

      try {
        await apiClient.post('/web/resend_verification', null, {
          params: {
            email: this.email,
          },
        });

        this.$toast.success('A new verification code has been sent to your email.');
        this.resetCountdown(); // Restart countdown timer
        console.log('Verification code resent successfully');
      } catch (error) {
        this.$toast.error(
          error.response?.data?.message ||
          'An error occurred while resending the verification code.'
        );
        console.error('Error resending verification code:', error);

      } finally {
        this.resending = false; // Reset the loading state
      }
    },


  },
mounted() {
    // Check for an existing countdown timestamp in localStorage
    const storedEndTime = localStorage.getItem('countdownEndTime');
    if (storedEndTime) {
      const remainingTime = Math.floor((new Date(storedEndTime) - new Date()) / 1000);
      if (remainingTime > 0) {
        this.countdown = remainingTime;
      } else {
        localStorage.removeItem('countdownEndTime'); // Clear expired timer
      }
    }

    this.startCountdown();
  },



  beforeUnmount() {
    // Clear the interval when the component is unmounted to prevent memory leaks
    clearInterval(this.intervalId);
  },
};
</script>

